<!--
게시판 컨텐츠 컴포넌트
  - 읽기모드
  - 수정모드
-->
<template>
    <div >
        <!-- 각 타입별 모듈 -->
        <component
            v-bind:is="contentModule"
            v-show="loadState === 'loaded'"
            :csrf-token="csrfToken"
            :content-id="contentId"
            :content="content"
            :hide-edit-button="hideEditButton"
            @done="listenEditDone"
        >
        </component>

        <!-- 로딩화면 -->
        <div v-show="loadState === 'loading'">
            <loading-icon
                class="uk-text-middle"
                bg-color="#ccc"
                fore-color="#333"
            ></loading-icon>
            loading...
        </div>

    </div>
</template>

<script>
    let module_text = require('./text/main.vue').default;
    let module_html = require('./html/main.vue').default;

    export default {
        components: {
            'loading-icon': require('../common/loading-icon.vue').default,
            //'text': require('./text/main.vue').default,
        },
        props: {
            /**
             * csrf token
             */
            csrfToken: {
                type: String,
                required: true,
            },

            /**
             * 컨텐츠ID
             */
            contentId: {
                type: Number,
                required: true,
            },

            /**
             * 수정버튼 표시안함
             */
            hideEditButton: {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            return {
                /**
                 * (string) 모듈
                 */
                contentModule: null,

                /**
                 * (int) 종류
                 */
                contentType: null,

                /**
                 * (string) 내용
                 */
                content: null,

                /**
                 * 데이터 로드 상태
                 *  - unload
                 *  - loading
                 *  - laoded
                 */
                loadState: 'unload',

            };
        },
        mounted: function () {
            // 로드
            this.load();
        },
        computed: {
        },
        methods: {
            /**
             * 컨텐츠 읽어오기
             */
            load() {
                if (this.loadState !== 'unload') {
                    return;
                }

                this.loadState = 'loading';
                // ajax 옵션
                let cmp = this;
                let opts = {
                    type: 'get',
                    url: '/board-contents/' + this.contentId,
                    dataType: 'json',
                    success(response, textStatus, jqXHR) {
                        let content = response.content;
                        cmp.contentType = content.type;
                        cmp.content = content.content;
                        cmp.loadState = 'loaded';

                        // 모듈로드
                        cmp.loadModule();
                    },
                    alert_error_msg(msg) {
                        alert(msg);
                        cmp.loadState = 'unload';
                    },
                };

                // ajax 실행
                $.app.ajax.module.background(opts);
            },

            /**
             * 모듈로드
             */
            loadModule() {
                if (this.contentType === 1) {
                    this.contentModule = module_text;
                } else if (this.contentType === 2) {
                    this.contentModule = module_html;
                }

            },

            /**
             * 수정완료 이벤트리스너
             */
            listenEditDone(msg) {
                UIkit.modal.alert(msg).then(function () {
                    $.app.refresh();
                });
            },
        },



    }
</script>

<style lang="scss" scoped>
</style>